import logo from  "../../assets/logo_dalkia-froid-solutions_RVB.svg";

const Logo = ({maxHeight, minWidth}) => {
  return (
    <img
      src={logo}
      alt="Logo"
      style={{maxHeight, minWidth}}
    />
  );
};

export default Logo;